module.exports = __webpack_public_path__ + "static/media/26910749_10215135996533800_8423361319728271364_o.81cf8631.jpg";